export default __webpack_public_path__ + "static/media/Flag_of_Saudi_Arabia.e09fabf0.svg";